import { useEffect, useState, type CSSProperties } from 'react'
import raisLogo from '../../assets/rais-nav.webp'
import { cn } from '../../lib/utils'

const sequence = {
  text: { duration: 14_000, next: 'text-out' },
  'text-out': { duration: 650, next: 'pause' },
  pause: { duration: 100, next: 'logo-in' },
  'logo-in': { duration: 480, next: 'logo' },
  logo: { duration: 1000, next: 'logo-out' },
  'logo-out': { duration: 500, next: 'text-in' },
  'text-in': { duration: 420, next: 'text' },
} as const
type Phase = keyof typeof sequence

/** Keep a stable navigation target and accessible name throughout the swap. */
export function RaisNavLabel() {
  const [phase, setPhase] = useState<Phase>('text')
  useEffect(() => {
    const timer = window.setTimeout(() => setPhase(sequence[phase].next), sequence[phase].duration)
    return () => window.clearTimeout(timer)
  }, [phase])
  return <span data-rais-phase={phase} style={{ '--rais-phase-duration': `${sequence[phase].duration}ms` } as CSSProperties} className="rais-nav-stage relative inline-grid h-9 w-11 shrink-0 place-items-center">
    <span className="sr-only">RAIS</span>
    <span aria-hidden="true" className={cn('rais-nav-text col-start-1 row-start-1', phase === 'text' && 'rais-nav-text-visible', phase === 'text-out' && 'rais-nav-text-out', phase === 'text-in' && 'rais-nav-text-in')}>RAIS</span>
    <img src={raisLogo} width={192} height={164} alt="" aria-hidden="true" draggable={false} className={cn('rais-nav-logo col-start-1 row-start-1 h-8 w-10 object-contain', phase === 'logo-in' && 'rais-nav-logo-in', phase === 'logo' && 'rais-nav-logo-hold', phase === 'logo-out' && 'rais-nav-logo-out')} />
  </span>
}
